<template>
    <Card class="connected-social-card text-center" v-bind:class="{['variant-' + variant]: variant}">
        <div v-if="variant == 'connected'">
            <div class="unlink-button-wrap">
                <Tooltip>

                    <template v-slot:trigger>
                        <Button variant="icon-wrap" class="unlink-button"><svgicon name="unlink" /></Button>
                    </template>
                    Click to unlink account
                </Tooltip>
            </div>
            <div class="width-100 relative text-center"><Avatar size="xl"></Avatar></div>
            <div class="social-card-title"><slot></slot></div>
            <div class="social-card-subtitle">{{title}}</div>
        </div>
        <div v-else class="break-after">
            <div class="flex-content">
                <div class="width-100 relative text-center">
                    <slot></slot>
                </div>
            </div>
        </div>
    </Card>
</template>
<script>
    import Card from '../../components/Card/Card';
    import Avatar from '../../components/Avatar/Avatar';
    import Button from '../../components/Button/Button';
    import Tooltip from '../../components/Tooltip/Tooltip';

    export default {
        name: 'ConnectedSocialCard',
        components: {
            Card,
            Avatar,
            Button,
            Tooltip
        },
        props: {
            variant: {
                type: String,
                default: 'connected'
            },
            title: {
                type: String,
                default: ''
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }
</script>
<style src="./ConnectedSocialCard.scss" scoped lang="scss"></style>

